export const EDIT_CORPORATE = "EDIT_CORPORATE";
export const EDIT_APARTMENT = "EDIT_APARTMENT";
export const EDIT_B2BALLIANCE = "EDIT_B2BALLIANCE";
export const EDIT_SUPPLY = "EDIT_SUPPLY";
